const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const {
  ALL_ORDERS_LIST,
  TOPAY_ORDERS_LIST,
  TOPACK_ORDERS_LIST,
  TOSHIP_ORDERS_LIST,
  TORECEIVE_ORDERS_LIST,
  TOCOMPLETE_ORDERS_LIST,
  RETURN_ORDERS_LIST,
  CANCEL_ORDERS,
  GET_ORDER_DETAILS,
  CANCEL_THE_ORDER,
  RECEIVED_ORDERS,
  TO_ACCEPT_ORDERS_LIST,
  TO_REDEEM_ORDERS_LIST,
} = require("./constants");

const {
  allOrdersListsSuccess,
  allOrdersListsError,

  toShipOrdersListsSuccess,
  toShipOrdersListsError,

  toPayOrdersListsSuccess,
  toPayOrdersListsError,

  toPackOrdersListsSuccess,
  toPackOrdersListsError,

  toRecieveOrdersListsSuccess,
  toRecieveOrdersListsError,

  toCompleteOrdersListsSuccess,
  toCompleteOrdersListsError,

  returnOrdersListsSuccess,
  returnOrdersListsError,

  cancelSuccess,
  cancelError,

  orderDetailsSuccess,
  orderDetailsError,

  cancelledOrdersSuccess,
  cancelledOrdersError,

  recievedOrdersSuccess,
  recievedOrdersError,

  toAcceptOrdersListsSuccess,
  toAcceptOrdersListsError,

  toRedeemOrdersListsSuccess,
  toRedeemOrdersListsError,
} = require("./actions");

const allOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(ALL_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => allOrdersListsSuccess(response.data))
        .catch((error) => allOrdersListsError(error))
    )
  );

const toPayOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TOPAY_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toPayOrdersListsSuccess(response.data))
        .catch((error) => toPayOrdersListsError(error))
    )
  );
const toPackOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TOPACK_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toPackOrdersListsSuccess(response.data))
        .catch((error) => toPackOrdersListsError(error))
    )
  );
const toShipOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TOSHIP_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toShipOrdersListsSuccess(response.data))
        .catch((error) => toShipOrdersListsError(error))
    )
  );
const toRecieveOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TORECEIVE_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toRecieveOrdersListsSuccess(response.data))
        .catch((error) => toRecieveOrdersListsError(error))
    )
  );

const toCompleteOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TOCOMPLETE_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toCompleteOrdersListsSuccess(response.data))
        .catch((error) => toCompleteOrdersListsError(error))
    )
  );
const cancelOrder = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CANCEL_ORDERS),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => cancelSuccess(response.data))
        .catch((error) => cancelError(error))
    )
  );

const returnOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(RETURN_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => returnOrdersListsSuccess(response.data))
        .catch((error) => returnOrdersListsError(error))
    )
  );

const orderDetails = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_ORDER_DETAILS),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .getOrder(marketplace, action.payload.orderId)
        .then((response) => orderDetailsSuccess(response.data))
        .catch((error) => orderDetailsError(error))
    )
  );
const cancelTheOrder = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CANCEL_THE_ORDER),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .cancelOrder(marketplace, action.payload.orderId)
        .then((response) => cancelledOrdersSuccess(response.data))
        .catch((error) => cancelledOrdersError(error))
    )
  );
const receivedOrder = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(RECEIVED_ORDERS),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .receivedOrder(marketplace, action.payload.orderId)
        .then((response) => recievedOrdersSuccess(response.data))
        .catch((error) => recievedOrdersError(error))
    )
  );

const toAcceptOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TO_ACCEPT_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toAcceptOrdersListsSuccess(response.data))
        .catch((error) => toAcceptOrdersListsError(error))
    )
  );

const toRedeemOrdersLists = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(TO_REDEEM_ORDERS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketOrder
        .listOrder(marketplace, action.payload.status, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => toRedeemOrdersListsSuccess(response.data))
        .catch((error) => toRedeemOrdersListsError(error))
    )
  );
module.exports = {
  allOrdersLists,
  toPayOrdersLists,
  toPackOrdersLists,
  toShipOrdersLists,
  toRecieveOrdersLists,
  toCompleteOrdersLists,
  cancelOrder,
  returnOrdersLists,
  orderDetails,
  cancelTheOrder,
  receivedOrder,
  toAcceptOrdersLists,
  toRedeemOrdersLists,
};
